import type {
  OrganizationDetail,
  OrganizationMinimal,
} from "./organization.type";
import type { UseGetOptions } from "@/hooks/queries";

import { useGet } from "@/hooks/queries";

export const useGetOrganization = <Organization = OrganizationDetail>(
  organizationId?: number,
  options?: UseGetOptions<Organization>
) => {
  const { data, ...queryResult } = useGet<Organization>(
    "organizations",
    organizationId,
    options
  );

  return {
    organization: data,
    ...queryResult,
  };
};

export const useGetOrganizationMinimal = (
  organizationId?: number,
  options?: UseGetOptions<OrganizationMinimal>
) => {
  return useGetOrganization<OrganizationMinimal>(organizationId, {
    ...options,
    params: {
      ...options?.params,
      "fields[organizations]": "id,name",
    },
  });
};
